export class AppConfig {
  static API = {
    CORE_URL: process.env.REACT_APP_CORE_URL || 'https://api.artcore.tech',
    LOCAL_URL: process.env.REACT_APP_LOCAL_URL || 'http://0.0.0.0:4000',
    INTELLIGENCE_URL: process.env.REACT_APP_INTELLIGENCE_URL || 'https://api.intelligence.artcore.tech',
    INTELLIGENCE_API_KEY: process.env.REACT_APP_INTELLIGENCE_API_KEY || 'a3f2c1b9e8d7f6a5b4c3d2e1f0a9b8c7d6e5f4a3b2c1d0e9f8a7b6c5d4e3f2a1'
  };

  static APP_NAME: string = 'Artcore Admin';
  static CONTACT_EMAIL: string = 'contact@artcore.tech';
  static CONTACT_INSTAGRAM: string = 'artcore.tech';
  static DEFAULT_COUNTRY_CODE: string = 'us';
  static BASE_URL = 'https://www.artcore.tech';

  static PLATFORM_SELLER_FEE_PERCENTAGE = 5;
  static PLATFORM_BUYER_FEE_PERCENTAGE = 5;

  // Listing validation thresholds
  static ORIGINAL_MARKING_MIN_PRICE_THRESHOLD = 500; // Price below this suggests it might not be an original
}
